import React, { useState } from "react";
import {useDispatch, useSelector } from "react-redux";
import { getSelectedTabstate, handleShowsummarymodal, setZipCodeVal,  getBuildingData } from "../../action/index.js";
import { stateManufacturerChange } from "../../action/manufacturers_auth/manufacture.action.js";
import { handleCommonModal } from "../../action/quote_order/leadcustomer.action.js";
import { params, const_var } from "../../redux/reducers/reducer";
import ZipcodeTooltip from "./ZipcodeTooltip.js";
import DepositOrder from "../ControlPanel/Common/DepositOrder/DepositOrder.js";
import { getDealerStateList } from "../../action/manufacturers_auth/manufacture.action.js";
import { setThankYouForSaveLaterValue } from "../../action/quote_order/quote.action.js";

const NavInfoItem = ({ className = "top-item-info", label, children }) => (
   <li className={className}>
      <label className="nav-info-name">{label}</label>
      <label className="nav-info-value">{children}</label>
   </li>
);

const EditIcon = ({ hidden }) => (
   <div className={hidden ? "d-none icon edit" : "icon edit"}>
      <span className="icon-edit-ico"></span>
   </div>
);

const useStateManufacturerName = (const_var, params) => {
   const baseName = const_var.stateNameAcordingAPI[params.selectedState];
   if (!baseName) return "";

   if (const_var.loginSession == true && params.m_s_n != "" && const_var.stateManufacturerAcordingAPIDiscount?.manuName?.[params.m_s_n]) {
      return `${baseName}, ${const_var.stateManufacturerAcordingAPIDiscount.manuName[params.m_s_n]}`;
   }
   return baseName;
};

const getDomainText = (main_domain_url) => {
   const domainMap = {
      "safeguardmetalbuildings.com": "A premier supplier of Carports, Garages, Metal Barns, and Steel Buildings",
      "custombuiltstructures.com": "Your Premier Steel Building Choice",
      "aametalbuildings.com": "America's #1 Dealer of Custom Metal Buildings. YOU WANT IT. WE GOT IT",
      "americanmetalbuildings.com": "American Metal Buildings offers extremely versatile metal buildings and steel structures across the USA",
      "eaglebuildings.com": "Our mission is to provide you with seamless experience, ensuring that every aspect of your metal building project is handled with the utmost care and precision",
      "fivestarmetalbuildings.com": "We Build Great Buildings"
   };
   return {
      bottomHighlightedText: domainMap[main_domain_url] ? "" : "Sensei 3D ",
      bottomText: domainMap[main_domain_url] || "sets the standard for how dreaming and designing metal buildings should feel - intuitive, full of options, and realistic."
   };
};

const useIsBtnDisabled = (isZipScreenEnable, showStateSel, const_var, params) => {
   if (
      isZipScreenEnable &&
      !showStateSel &&
      (const_var.state_mfg_zipcode == "" ||
         const_var.state_mfg_zipcode?.length != 5 ||
         (const_var.ziperrormsg != "" && const_var.ziperrormsg != undefined) ||
         (const_var.displayerrorMessage?.zipcode != undefined && const_var.displayerrorMessage.zipcode != "") ||
         const_var.SApiCalled == undefined ||
         const_var.SApiCalled == false)
   )
      return true;

   if ((!isZipScreenEnable || showStateSel) && (!params.p_s_n) && (!params.m_s_n)) return true;

   if (
      (isZipScreenEnable && const_var.state_mfg_zipcode != "" && const_var.state_mfg_zipcode?.length != 5) ||
      (showStateSel && !params.p_s_n && !params.m_s_n)
   )
      return true;

   if (
      isZipScreenEnable &&
      const_var.SApiCalled == true &&
      const_var.isZipcodeIncluded != undefined &&
      const_var.isZipcodeIncluded == false &&
      const_var.showStateZip == false &&
      const_var.crmSetting.is_CRM == true
   )
      return true;

   return false;
};

const BuildingSummary = () => {
   const dispatch = useDispatch();
   const { const_var, params,selectedTabstate,defaultBuilding } = useSelector((state) => state.reducer);
   const { thankYouForSaveLater } = useSelector((state) => state.quoteReducer);

   const [isShowZipTooltip, setIsShowZipTooltip] = useState(false);
   const lastN = const_var?.LeadCustomerData?.last_name  ||  "";

   const ActiveclassnoCursor = const_var.crmSetting.is_quote_Edit === true;

   if (params.add_left_lean) const_var.leanHeight = params.lean_p_h;
   if (params.add_right_lean) const_var.leanHeight = params.leanR_p_h;
   if (params.add_front_lean) const_var.leanHeight = params.leanF_p_h;
   if (params.add_back_lean) const_var.leanHeight = params.leanB_p_h;

   let showStateSel = false;
   const isZipScreenEnable = const_var.crmSetting?.is_zipcode_screen === true;

   if (
      isZipScreenEnable &&
      const_var?.is_State_Edit &&
      const_var?.state_mfg_zipcode &&
      !const_var?.tempZCode
   ) {
      const_var.tempZCode = const_var.state_mfg_zipcode;
   }

   if (isZipScreenEnable && (const_var.resetVal === true || (const_var?.is_State_Edit && const_var?.state_mfg_zipcode))) {
      // setZipInputValue() equivalent — preserved as-is (external side effect)
   }

   if (thankYouForSaveLater == true) {
      dispatch(setThankYouForSaveLaterValue(false));
   }

   if (isZipScreenEnable && (const_var?.showStateZip || (const_var.is_State_Edit && const_var.hodldEditBuildingData && !const_var?.hodldEditBuildingData?.state_mfg_zipcode))) {
      showStateSel = true;
   }
   let callApifun = true;
   if (const_var.stateChangeflag != "" && const_var.stateChangeflag == params.p_s_n) callApifun = false;
   if (const_var.stateMenuChangeflag != params.m_s_n) callApifun = true;

   const isUserData = !!localStorage.getItem("userData");

   // ── Auto-select single building logic ──────────────────────────────────────
   const firstManufacrure = const_var.bjDData[0]?.manufacturer_list;
   if (
      const_var.crmSetting.is_Edit != true &&
      const_var.bjDData.length == 1 &&
      ((Array.isArray(firstManufacrure) && firstManufacrure?.length > 0) || !Array.isArray(firstManufacrure)) && !const_var.isFromPickThis) {
      if (const_var.crmSetting?.pre_quote_form && !const_var.loginSession && !const_var.showStateField && !const_var.showStateOnly) {
         params.p_s_n = const_var.bjDData[0].id;
         params.m_s_n = const_var.bjDData[0].manufacturer_list.id;
         dispatch(stateManufacturerChange(params.p_s_n, "state"));
      } else {
         if (isZipScreenEnable && const_var.loginSession == true && params.m_s_n != "") {
            // no-op: already set
         } else if (isZipScreenEnable && const_var.loginSession == false) {
            params.p_s_n = const_var.bjDData[0].id;
            params.m_s_n = const_var.bjDData[0].manufacturer_list.id;
            dispatch(stateManufacturerChange(params.p_s_n, "state"));
         } else {
            params.p_s_n = const_var.bjDData[0].id;
            params.m_s_n = isUserData ? const_var.bjDData[0].manufacturer_list[0].id : const_var.bjDData[0].manufacturer_list.id;
            dispatch(stateManufacturerChange(params.p_s_n, "state"));
            if (!const_var.crmSetting?.is_zipcode_screen) {
               const_var.confirmState = true;
               dispatch(getBuildingData(params));
            }
         }
      }
   }
   const { bottomHighlightedText, bottomText } = getDomainText(const_var.crmSetting.main_domain_url);
   const isBtnDisabled = useIsBtnDisabled(isZipScreenEnable, showStateSel, const_var, params);
   const stateManufacturerName = useStateManufacturerName(const_var, params);
   let showPriceDiv =
      (const_var.loginSession == true || const_var.isKLinkEnable == true || const_var.is_Edit == true || const_var.loginSession?.isPublicEdit == true || const_var.hide_price_calculation == false) == true;

   if (const_var.isKLinkEnable == true && const_var.hide_price_calculation == true) showPriceDiv = false;
   if (const_var.loginSession == false && const_var.checkmoreCustomizeFlag == true) showPriceDiv = false;
   if (selectedTabstate == "statechange" || selectedTabstate == "buildstyle" || selectedTabstate == "loginstyletab") showPriceDiv = false;
   if (const_var.post_data == undefined) showPriceDiv = false;

   const SizeSummaryLabel = () => {
      const dispatch = useDispatch();
      const isFreeStandingLeanTo = const_var.b_o_J_1[params.p_b_t] != undefined && const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to");
      const hasSingleLeanto = const_var.post_data?.building?.leanto?.length == 1;
      const handleClick = () => {
         dispatch(handleShowsummarymodal());
      };

      if (isFreeStandingLeanTo) {
         const roundFn = const_var.c_m_a[params.p_b_t]?.fixed_new_leg_width?.length > 0 ? Math.floor : Math.round;
         return (
            <a className="text size-summary-text" onClick={handleClick}>
               {params.p_w}' W x {params.p_d}' L x {params.p_h}' / {roundFn(params.p_h - (params.p_w * params.p_r_p) / 12)}' H
            </a>
         );
      }

      if (hasSingleLeanto) {
         return (
            <a className="text size-summary-text" onClick={handleClick}>
               {params.p_w}' W x {params.p_d}' L x {params.p_h}' / {const_var.leanHeight}' H
            </a>
         );
      }

      return (
         <a className="text size-summary-text" onClick={handleClick}>
            {params.p_w}' W x {params.p_d}' L x {params.p_h}' H
         </a>
      );
   };

   return (
      <>
         <ul className="top-info" data-tut="headpaneloption">
            {const_var.crmSetting.is_Edit == true && const_var.crmSetting.form_action != "duplicate" && const_var.checkPickThisBuilding != true && const_var.isKLinkEnable != true && (
               <NavInfoItem label="ID">{const_var.crmSetting.module_id_string}</NavInfoItem>
            )}
            {!const_var.is_intel && (
               <>
                  {const_var.stateNameAcordingAPI[params.selectedState] != undefined && (
                     <NavInfoItem className={selectedTabstate == "statechange" ? "top-item-info d-none" : "top-item-info"} label={const_var.loginSession == true ? "State & Manufacturer" : "State"}>
                        <label id="statemanufacturetooltip" className="nav-info-value" onClick={() => setIsShowZipTooltip(!isShowZipTooltip)}>
                           <div className={`text ${const_var.loginSession ? "state-manufacture-text" : "non-loggedIn-state-manufacture-text"}`}>{stateManufacturerName}</div>
                           <EditIcon hidden={ActiveclassnoCursor} />
                        </label>
                        <ZipcodeTooltip isShowZipTooltip={isShowZipTooltip} setShowTooltip={(value) => setIsShowZipTooltip(value)} />
                     </NavInfoItem>
                  )}
               </>
            )}
            {defaultBuilding != undefined && defaultBuilding != "" && (
               <>
                  <li className={selectedTabstate == "buildstyle" ? "top-item-info d-none" : "top-item-info d-none"}>
                     <label className="nav-info-name">Building Type</label>
                     <label className="nav-info-value" onClick={() => dispatch(getSelectedTabstate("buildstyle"))}>
                        {params.building_type_name}
                        <a className={ActiveclassnoCursor ? "d-none icon edit" : "icon edit"}>
                           <span className="icon-edit-ico"></span>
                        </a>
                     </label>
                  </li>
                  {/* Lead Name */}
                  {const_var.loginSession && const_var.crmSetting.is_show_cta != true && const_var.crmSetting.is_module_name != "inventory" && (
                     <NavInfoItem className={selectedTabstate == "statechange" ? "top-item-info d-none" : "top-item-info"} label="Lead Name">
                        <label className="nav-info-value" onClick={() => dispatch(handleCommonModal("lead_customer"))}>
                           <span className="text lead-name-text">
                              {const_var.LeadCustomerData.first_name != undefined && const_var.LeadCustomerData.first_name != "" ? `${const_var.LeadCustomerData.first_name} ${lastN}` : "Select"}
                           </span>
                           <span className={ActiveclassnoCursor ? "d-none icon edit" : "icon edit"}>
                              <span className="icon-edit-ico"></span>
                           </span>
                        </label>
                     </NavInfoItem>
                  )}

                  {/* Size & Summary */}
                  <li className={selectedTabstate == "statechange" || selectedTabstate == "buildstyle" || selectedTabstate == "loginstyletab" ? "top-item-info d-none" : "top-item-info sizeSummary"}>
                     <label className="nav-info-name">Size &amp; Summary</label>
                     <label className="nav-info-value">
                        <SizeSummaryLabel />
                        <span className="icon caret">
                           <i className="icon-arrow-down-ico" onClick={()=>dispatch(handleShowsummarymodal())}></i>
                        </span>
                     </label>
                  </li>

                  {/* Price / Deposit */}
                  <li className={showPriceDiv ? "top-item-info deposit-price" : "top-item-info deposit-price d-none"}>
                     <div className="drop-wrap-price">
                        <DepositOrder />
                     </div>
                  </li>
               </>
            )}
         </ul>
      </>
   );
};

export default BuildingSummary;